import React, { useState } from 'react';
import { MainContentPanel } from '../../components/MainContentPanel';
import { Typography, Tabs, Tab, FormControlLabel, Switch, Box, Divider } from '@mui/material';
import { UsersInSubscription } from './UsersInSubscription';
import { GET_SUBSCRIPTIONS } from './UsersInLicense.graphql';

import LoadingSpinner from '../../components/LoadingSpinner';
import { LicenseSubscription } from '../../interfaces';
import { AddUsers } from './AddUsers';
import { SecuritySettings } from './SecuritySettings';
import { useQuery } from '@apollo/client/react';

interface Props {
  licenseId: number;
}

export function UsersInLicense({ licenseId }: Props) {
  const [shouldIncludeRemovedUsers, setShouldIncludeRemovedUsers] = useState(false);

  const { loading, error, data, refetch } = useQuery<{ subscriptions: LicenseSubscription[] }, { id: number; shouldIncludeRemovedUsers: boolean }>(GET_SUBSCRIPTIONS, {
    variables: { id: licenseId, shouldIncludeRemovedUsers },
  });

  console.log({ 'userinlicense that I need': data });

  const handleToggle = (checked: boolean) => {
    setShouldIncludeRemovedUsers(checked);
    refetch({ id: licenseId, shouldIncludeRemovedUsers: checked });
  };

  if (error)
    return (
      <UsersPanel shouldIncludeRemovedUsers={shouldIncludeRemovedUsers} onToggleRemovedUsers={handleToggle}>
        <pre>`Uffda! ${error.message}`</pre>
      </UsersPanel>
    );
  if (loading || !data)
    return (
      <UsersPanel shouldIncludeRemovedUsers={shouldIncludeRemovedUsers} onToggleRemovedUsers={handleToggle}>
        <LoadingSpinner />
      </UsersPanel>
    );

  if (data.subscriptions.length === 0) return null;

  return (
    <UsersPanel
      subscriptions={data.subscriptions}
      shouldIncludeRemovedUsers={shouldIncludeRemovedUsers}
      onToggleRemovedUsers={handleToggle}
    >
      <SubscriptionsTabs subscriptions={data.subscriptions} />
    </UsersPanel>
  );
}

interface TabsProps {
  subscriptions: LicenseSubscription[];
}

function SubscriptionsTabs({ subscriptions }: TabsProps) {
  const [value, setValue] = useState(0);
  return (
    <Box>
      <Tabs value={value} onChange={(ev, val) => setValue(val)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        {subscriptions.map((x) => (
          <Tab key={x.subscription.id} label={x.subscription.name} />
        ))}
      </Tabs>
      <Box sx={{ pt: 3 }}>
        {subscriptions.map((x, index) => {
          return value === index && <UsersInSubscription key={x.subscription.id} subscription={x} />;
        })}
      </Box>
    </Box>
  );
}

function UsersPanel({
  subscriptions,
  children,
  shouldIncludeRemovedUsers,
  onToggleRemovedUsers
}: {
  subscriptions?: LicenseSubscription[];
  children: any;
  shouldIncludeRemovedUsers?: boolean;
  onToggleRemovedUsers?: (value: boolean) => void;
}) {
  return (
    <MainContentPanel sx={{ marginRight: 0 }}>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h5" component="h2">
              Brukere
            </Typography>
            {subscriptions && <AddUsers subscriptions={subscriptions} />}
            {subscriptions && <SecuritySettings subscriptions={subscriptions} />}
          </Box>
          {onToggleRemovedUsers && (
            <FormControlLabel
              control={
                <Switch
                  checked={shouldIncludeRemovedUsers}
                  onChange={(e) => onToggleRemovedUsers(e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label={
                <Typography variant="body2" sx={{
                  color: "text.secondary"
                }}>
                  Inkluder fjernede brukere
                </Typography>
              }
              sx={{ ml: 2 }}
            />
          )}
        </Box>
        <Divider />
      </Box>
      {children}
    </MainContentPanel>
  );
}